import axios from 'axios';
import { API_BASE_URL, API_ENDPOINTS } from '@/config/api.config';

class SurveyService {
  async createSurvey(data) {
    const response = await axios.post(
      `${API_BASE_URL}${API_ENDPOINTS.SURVEY.BASE}`,
      data,
    );
    return response.data;
  }
  async updateSurvey(id, data) {
    const response = await axios.put(
      `${API_BASE_URL}${API_ENDPOINTS.SURVEY.BASE}/${id}`,
      data,
    );
    return response.data;
  }

  async getSurveyByToken(token) {
    const response = await axios.get(
      `${API_BASE_URL}${API_ENDPOINTS.SURVEY.BASE}/resume/${token}`,
    );
    return response.data;
  }
  /**
   * De quoi peupler les filtres a choix multiple: gouvernorats, secteurs,
   * exercices et auteurs reellement presents. Un professionnel n'y voit que ce
   * que ses propres enquetes contiennent.
   */
  async getFilterOptions() {
    const response = await axios.get(
      `${API_BASE_URL}${API_ENDPOINTS.SURVEY.FILTER_OPTIONS}`,
    );
    return response.data;
  }

  async getSurveys(params) {
    const response = await axios.get(
      `${API_BASE_URL}${API_ENDPOINTS.SURVEY.BASE}`,
      { params },
    );
    return response.data;
  }
  async deleteSurveySubmission(id) {
    const response = await axios.delete(
      `${API_BASE_URL}${API_ENDPOINTS.SURVEY.BY_ID(id)}`,
    );
    return response;
  }
  async getSurveySubmissionById(id) {
    const res = await axios.get(
      `${API_BASE_URL}${API_ENDPOINTS.SURVEY.BY_ID(id)}`,
    );
    return res.data;
  }
  async exportSurveys(params = {}) {
    const resp = await axios.get(
      `${API_BASE_URL}${API_ENDPOINTS.SURVEY.EXPORT}`,
      {
        params,
        responseType: 'blob',
      },
    );
    return resp.data;
  }
}

export default new SurveyService();
